import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import CCApp from './Apps/CC/src/App';
import TCApp from "./Apps/TC/src/App";
import HSApp from "./Apps/HS/src/App";

import LandingLayout from './layouts/LandingLayout/LandingLayout';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import Home from "./Pages/Home/Home";
import About from './Pages/About/About';
import Contact from './Pages/Contact/Contact';
import TermsAndConditions from './Pages/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import EmailSettings from "./Pages/EmailSettings/EmailSettings";
import { ROUTE_PATHS } from './Config/routes';
import ToastContext from './Context/Toaster/Toaster';
import AccessDenied from './Pages/AccesDenied/AccessDenied';

const App = () => {

  return (
    <Router>
      <ScrollToTop />
      <ToastContext />
      <Routes>
        <Route path="/cc/*" element={<CCApp />} />
        <Route path="/tc/*" element={<TCApp />} />
        <Route path="/hs/*" element={<HSApp />} />

        <Route element={<LandingLayout />}>
          <Route path={`/${ROUTE_PATHS.HOME}`} element={<Home />} />
          <Route path={`/${ROUTE_PATHS.ABOUT}`} element={<About />} />
          <Route path={`/${ROUTE_PATHS.CONTACT}`} element={<Contact />} />
          <Route path={`/${ROUTE_PATHS.TERMS}`} element={<TermsAndConditions />} />
          <Route path={`/${ROUTE_PATHS.PRIVACY}`} element={<PrivacyPolicy />} />
        </Route>
        <Route path='/email-settings' element={<EmailSettings />} />
        <Route path="/access-denied" element={<AccessDenied />} />
        <Route path="*" element={<div>Page Not Found</div>} />
      </Routes>
    </Router>
  );
};

export default App;
